import React from "react";
import CommonControl from "./CommonControl";
import { useTranslation } from "react-i18next";

const OnSiteIt = (props) => {
  const { t } = useTranslation("form");

  return (
    <React.Fragment>
      <CommonControl {...props} keyName={'onSiteIT'} title={t("onsiteIt")} arr={['role','first_name_prefix','last_name','email','phone']} required={false} />
    </React.Fragment>
  );
};

export default OnSiteIt;
